import React, { useState, useEffect } from 'react';
import {
  CheckCircle,
  HourglassEmpty,
  Cancel,
  RadioButtonChecked,
  Restore
} from '@material-ui/icons';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import Button from 'components/CustomButtons/Button';
import { currency, nDecimal } from 'hooks/Pipe';
import { wsGetAll } from 'services/WService';
import Badge from 'components/Badge/Badge';
import moment from 'moment';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 75 },
  { Header: 'Zona', accessor: 'zone', width: 80 },
  { Header: 'Estado', accessor: 'state', excelEnabled: false, width: 140 },
  { Header: 'HR', accessor: 'id', width: 80 },
  { Header: 'Facturacion', accessor: 'facturation_date', width: 140 },
  { Header: 'Inicio Fact.', accessor: 'facturation_date_start', width: 140 },
  { Header: 'Fin Fact.', accessor: 'facturation_date_end', width: 140 },
  { Header: 'Ref', accessor: 'reference', width: 80 },
  { Header: 'Avance', accessor: 'advance', width: 80 },
  { Header: 'Vehiculo', accessor: 'codeVehicle', width: 90 },
  { Header: 'Jefe reparto', accessor: 'distManager' },
  { Header: 'Enc. mercadería', accessor: 'distInventoryManager' },
  { Header: 'Programación', accessor: 'scheduledDate', width: 135 },
  { Header: 'Despacho', accessor: 'dispatchDate', width: 135, align: 'right' },
  { Header: 'Monto', accessor: 'amount', width: 100, align: 'center' },
  { Header: 'Cli.', accessor: 'customers', width: 60, align: 'right' },
  { Header: 'Peso', accessor: 'weight', width: 70, align: 'right' },
  { Header: 'Vol.', accessor: 'volume', width: 70, align: 'right' },
  { Header: 'Nombre almacén', accessor: 'warehouse', width: 215 },
  { Header: 'Ult. Proceso', accessor: 'processDate', width: 150 },
  { Header: 'Mensaje error', accessor: 'errorMessage', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

const listStates = [
  { id: 'N', name: 'Creado', color: 'info', icon: <RadioButtonChecked /> },
  { id: 'G', name: 'Generado', color: 'info', icon: <RadioButtonChecked /> },
  { id: 'A', name: 'Anulado', color: 'danger', icon: <Cancel /> },
  { id: 'F', name: 'Facturado', color: 'warning', icon: <HourglassEmpty /> },
  { id: 'W', name: 'En Reparto', color: 'success', icon: <CheckCircle /> },
  {
    id: '1',
    name: 'Liq. de mercaderia',
    color: 'success',
    icon: <CheckCircle />
  },
  {
    id: '2',
    name: 'Liq. de mercaderia +',
    color: 'success',
    icon: <CheckCircle />
  },
  {
    id: '3',
    name: 'Liq. de documento',
    color: 'success',
    icon: <CheckCircle />
  },
  {
    id: '4',
    name: 'Liq. de documento +',
    color: 'success',
    icon: <CheckCircle />
  },
  { id: 'L', name: 'Liq. HR', color: 'success', icon: <CheckCircle /> },
  { id: '5', name: 'Cerrado', color: 'primary', icon: <Cancel /> }
];
export default function AdvanceInvoice() {
  const [programmings, setProgrammings] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listProgramming() {
    setDataLoading(true);
    let response = await wsGetAll('prog/sheet-distribution/facturation?with_count=Y');
    setDataLoading(false);
    if (response.success) setProgrammings(response.data);
  }

  useEffect(() => {
    listProgramming();
  }, []);

  return (
    <CardContainer /*title="Listado de avance facturación HR"*/ title={(<>Listado de avance facturación HR {dataLoading && <LoadingSpinner />}</>)}>
      <ReactTable
        excelName="Programaciones"
        defaultWidth={2500}
        columns={columns}
        formatDate="DD-MM-YYYY"
        data={programmings.map((prog, i) => {
          let color = 'danger';
          let state = '-';
          let hasError = false;
          let stateIndex = listStates.findIndex((obj) => obj.id == prog.state);
          if (stateIndex !== -1) {
            color = listStates[stateIndex].color;
            state = listStates[stateIndex].name;
          }
          if (prog.state === 'A' && prog.sapAnnuled === 'P') {
            color = 'warning';
            state = 'Anulando...';
          }
          if (prog.state === 'F' && 'error_orders' in prog) {
            hasError = true;
            color = 'danger';
            state = 'Error!';
          }

          return {
            num: i + 1,
            zone: prog.base_zone_description,
            state: (
              <div>
                <Badge color={color}>{state}</Badge>
                {hasError && (
                  <Button
                    size="sm"
                    color="danger"
                    justIcon
                    simple
                    round
                  // onClick={() => setErrorOrderOpen(prog)}
                  >
                    <Restore />
                  </Button>
                )}
              </div>
            ),
            action: (
              <div className="actions-right">
              </div>
            ),
            id: prog.id.toString(),
            facturation_date: prog.facturation_date !== null ? moment(prog.facturation_date).format('hh:mm:ss') : '-',
            facturation_date_start: prog.facturation_date_start !== null ? moment(prog.facturation_date_start).format('hh:mm:ss') : '-',
            facturation_date_end: prog.facturation_date_end !== null ? moment(prog.facturation_date_end).format('hh:mm:ss') : '-',
            reference: prog.reference,
            advance: (
              <>
                {prog.facturados} - {prog.orders}
              </>
            ),
            codeVehicle: prog.prog_vehicle_code,
            distManager: prog.manager_name,
            distInventoryManager: prog.inventory_manager_name,
            scheduledDate: prog.scheduled_date,
            dispatchDate: prog.dispatch_date,
            amount: currency(prog.amount),
            customers: prog.customers,
            weight: nDecimal(prog.weight),
            volume: nDecimal(prog.volume),
            warehouse: prog.logi_warehouse_name,
            processDate: prog.last_process_date,
            errorMessage: prog.error_message || '-',
            actions: '',
          };
        })}
      />
    </CardContainer>
  );
}
